export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/articles_blog_posts.a4fcbdb.svg";